// Auto-generated file.
// Don't edit/delete it manually!

import type {ComponentProps, ComponentType} from 'react';
import React, {forwardRef} from 'react';

const ADD_COLUMN = forwardRef((props, ref) => {
    return (
        
<svg {...props} version="1.1" xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12">
<path fill="#fff" d="M9 5.229h4.629v5.829h-4.629v-5.829z"></path>
<path fill="#fff" d="M4.629 5.314h2.143v5.743h-2.143v-5.743z"></path>
<path fill="#f3d1ff" d="M4.2 2.914v2.4h9v-2.4h-6.771z"></path>
<path fill="#c590d9" d="M6.686 0.343h2.314v8.143h-2.314v-8.143z"></path>
<path fill="#9469a4" d="M11.229 2.486h-1.886v-2.486h-3.086v2.486h-2.486v6.943h-0.771v-1.2h-1.714v1.286h-1.286v1.714h1.286v0.771h1.714v-0.771h0.771v0.171h3.086v-2.486h1.286v2.486h5.571v-8.914h-2.486zM6 10.543h-1.371v-4.886h1.371v4.886zM6 4.8h-1.371v-1.457h1.371v1.457zM8.486 2.486h-0.343v5.486h-1.029v-7.114h1.371c0 0 0 1.629 0 1.629zM10.371 10.543h-1.371v-1.629h0.429v-3.257h1.029l-0.086 4.886zM10.371 4.8v0h-1.371v-1.457h1.371v1.457zM12.857 10.543h-1.371v-4.886h1.371v4.886zM12.857 4.8h-1.371v-1.457h1.371v1.457z"></path>
</svg>

    );
}) as ComponentType<ComponentProps<'svg'>>;

export default ADD_COLUMN;
